export const nzmWrapStyle =  {
  NzmFlash: {
    m01 : {
      minWidth: '7.5rem',
      minHeight: '2rem',
    },
    m02 : {
      minWidth: '7.1rem',
      minHeight: '1.6rem',
    },
    m03 : {
      minWidth: '7.1rem',
      minHeight: '4rem',
    },
    m04 : {
      minWidth: '7.5rem',
      minHeight: '4.22rem',
    },
    m05 : {
      minWidth: '7.5rem',
      minHeight: '3.21rem',
    },
    m06 : {
      minWidth: '7.5rem',
      minHeight: '7.5rem',
    },
  },
  NzmImgScroll: {
    m01: {
      minHeight: '1.2rem',
    },
    m02: {
      minHeight: '1.57rem',
    },
  },
  NzmImgMultiLine: {
    m01: {
        minHeight: '2rem',
    },
    m02: {
        minHeight: '2rem',
    },
    m03: {
        minHeight: '2rem',
    },
    m04: {
      minHeight: '2rem',
    },
    m05: {
      minHeight: '2rem',
    },
    m06: {
      minHeight: '2rem',
    },
  },
  NzmUserInfo: {
    minHeight: '1.33rem',
  }
}

export function getNzmWrapStyle(info) {
  if(nzmWrapStyle[info.comp_code]){
    if(info.config.show_type){
      return nzmWrapStyle[info.comp_code][info.config.show_type]
    }else{
      return nzmWrapStyle[info.comp_code]
    }
  }
}

